import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgVBoats = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 16"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M34.706 9.462c.405-.364.663-.745.721-.894.126-.32 1.257-8.1 1.257-8.1S40.2 0 43.844 0s6.784.343 6.784.343 1.257 5.905 2.01 7.288c.26.474.592.808.918 1.051 8.482-.174 14.924-.096 16.544-.096 4.9 0 40.328.552 45.603.552 5.278 0 19.599 2.762 21.985 2.762h22.11c8.658 0 25.248 2.842 29 3.505.782-.32.776-1.116.776-1.116s1.256-4.398 1.506-5.721c.251-1.323 1.383-1.818 1.383-1.818h5.653c1.759 0 1.884 1.818 1.884 1.818v6.977H0c7.278-3.442 21.167-5.195 34.706-6.083"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgVBoats
